import comp from "./AIPanelDialogs";
export default comp;
